import useSwr from "@/core/composables/swr/useSwr";
import {dosageApi} from "@/container";

/**
 * SWR composable for fetching dosage frequencies.
 */
const useDosageFrequencies = () => {
    return useSwr("dosage-frequencies", () => dosageApi().dosageFrequencies());
};

export default useDosageFrequencies;
